import { LitElement, css, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators';

import { StateController } from '../../helpers/state/state-management/state-controller';
import accountInfo from '../../helpers/state/account-info';
import { palette } from '../../style/variables';
import { getMainPage } from '../../helpers/page-name';

@customElement('confirm-delete-component')
export class ConfirmDeleteComponent extends LitElement {
    static amplitude_callsite: string = 'Confirm Delete Modal';



    @property({ type: String })
    confirmMessage?: string;

    private readonly bindAccountState = new StateController(this, accountInfo);

    handleChangeForm(e: any) {
        this.confirmMessage = e.detail.value;
    }

    private async handleClick() {
        await getMainPage().errorToastElement.tryOrErrorToast(async () => {
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            if (this.confirmMessage?.toUpperCase() !== 'DELETE') throw '';
            await accountInfo.deleteAccountInfo();
        }, 'An error has occurred.  Context: Confirmation message does not match required message "DELETE".');
    }

    render() {
        return html`
            <modal-header>Delete your account?</modal-header>
            <p>
                WARNING<br />
                If you have an active or in-trial subscription, you must cancel your subscription <b>before</b> deleting your account.
                This delete will not cancel your subscription.
                <br /> <br />
                If you delete your account, all bookmarks and account information will
                be deleted. The maps you have created will still exist and can be accessed by other
                admins, but you will not be able to access these maps unless you recreate your
                account.
            </p>
            <div>
                <div class="deleteInputSection">
                    <form-input
                        id="name"
                        type="text"
                        label="Type 'DELETE' below to confirm account deletion."
                        .value="${this.confirmMessage}"
                        required
                        @change="${this.handleChangeForm}">
                    </form-input>
                </div>
                <form-button
                    type="submit"
                    id="deleteBtn"
                    @click="${this.handleClick}"
                    ?fullWidth=${true}>
                    DELETE ACCOUNT
                </form-button>
                <error-toast id="errorToast"></error-toast>
            </div>
        `;
    }

    static get styles() {
        return css`
            .deleteInputSection {
                margin-bottom: 1rem;
            }

            #deleteBtn {
                --btn-background-color: ${unsafeCSS(palette.failureRed)};
            }
        `;
    }
}
